import { render, staticRenderFns } from "./AccountProfileOrdersAll.vue?vue&type=template&id=53a253e0&"
import script from "./AccountProfileOrdersAll.vue?vue&type=script&lang=js&"
export * from "./AccountProfileOrdersAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports